import { render, staticRenderFns } from "./nav-item-list.vue?vue&type=template&id=c6f61f04&scoped=true&"
import script from "./nav-item-list.vue?vue&type=script&lang=ts&"
export * from "./nav-item-list.vue?vue&type=script&lang=ts&"
import style0 from "./nav-item-list.vue?vue&type=style&index=0&id=c6f61f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f61f04",
  null
  
)

export default component.exports